import React, { useState, useRef } from 'react';
import ImageDropzone from '../ImageDropzone';
import { uploadImage, resolveImageUrl } from '../../services/api';

const Req = () => <span style={{ color: '#e53e3e', marginLeft: '3px', fontWeight: '700' }}>*</span>;

const ProjectModal = ({ editItem, modalImageUrl, setModalImageUrl, modalImageUrls, setModalImageUrls, onSave, onClose }) => {
    const isEdit = !!editItem;

    const [category, setCategory] = useState(editItem?.category || 'ACP Front Elevation');
    const [images, setImages] = useState(isEdit ? (modalImageUrl ? [modalImageUrl] : []) : (modalImageUrls && modalImageUrls.length > 0 ? modalImageUrls : []));
    const [uploadingCount, setUploadingCount] = useState(0);
    const [isDragging, setIsDragging] = useState(false);
    const [showUrlInput, setShowUrlInput] = useState(false);
    const [urlText, setUrlText] = useState('');
    const bulkInputRef = useRef(null);

    const getPreviewUrl = (img) => {
        if (!img) return '';
        if (typeof img === 'string') {
            if (img.startsWith('http://') || img.startsWith('https://') || img.startsWith('data:')) return img;
            return resolveImageUrl(img);
        }
        return '';
    };

    const handleFilesSelect = async (fileList) => {
        if (!fileList || fileList.length === 0) return;
        const filesArray = Array.from(fileList).filter(f => f.type.startsWith('image/'));
        if (filesArray.length === 0) {
            alert('Please select valid image files (JPG, PNG, WEBP, SVG).');
            return;
        }

        setUploadingCount(filesArray.length);
        const uploadedUrls = [];

        for (let i = 0; i < filesArray.length; i++) {
            const file = filesArray[i];
            try {
                const res = await uploadImage(file);
                if (res && res.success && res.url) {
                    uploadedUrls.push(res.url);
                } else {
                    await new Promise((resolve) => {
                        const reader = new FileReader();
                        reader.onload = (e) => {
                            uploadedUrls.push(e.target.result);
                            resolve();
                        };
                        reader.readAsDataURL(file);
                    });
                }
            } catch (err) {
                await new Promise((resolve) => {
                    const reader = new FileReader();
                    reader.onload = (e) => {
                        uploadedUrls.push(e.target.result);
                        resolve();
                    };
                    reader.readAsDataURL(file);
                });
            }
            setUploadingCount(filesArray.length - (i + 1));
        }

        setUploadingCount(0);
        setImages(prev => [...prev, ...uploadedUrls]);
    };

    const removeImage = (indexToRemove) => {
        setImages(prev => prev.filter((_, idx) => idx !== indexToRemove));
    };

    const handleAddUrl = () => {
        if (urlText && urlText.trim()) {
            setImages(prev => [...prev, urlText.trim()]);
            setUrlText('');
            setShowUrlInput(false);
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (isEdit) {
            setModalImageUrl(images[0] || '');
            onSave(e);
        } else {
            onSave(e, category, images);
        }
    };

    return (
        <div className="admin-modal-overlay" onClick={onClose}>
            <div className="admin-modal-card" onClick={(e) => e.stopPropagation()} style={{ maxWidth: isEdit ? '520px' : '680px', width: '90%' }}>
                <div className="admin-modal-header">
                    <h3>{isEdit ? 'Edit Project Image' : 'Add New Project Images (Bulk Upload)'}</h3>
                    <button className="close-btn" onClick={onClose}>✕</button>
                </div>
                <form onSubmit={handleSubmit} className="admin-modal-body">
                    <div style={{ marginBottom: '18px' }}>
                        <label className="admin-label">Category<Req /></label>
                        <select
                            name="category"
                            value={category}
                            onChange={(e) => setCategory(e.target.value)}
                            className="admin-input"
                            style={{ width: '100%', height: '42px', fontWeight: '600', backgroundColor: '#ffffff', cursor: 'pointer' }}
                            required
                        >
                            <option value="ACP Front Elevation">ACP Front Elevation</option>
                            <option value="Facade Glazing">Facade Glazing</option>
                            <option value="Toughened Glass">Toughened Glass</option>
                        </select>
                    </div>

                    {isEdit ? (
                        <ImageDropzone
                            label="Project Image"
                            value={images[0] || ''}
                            onChange={(val) => setImages([val])}
                            fallback="/images/projects/portrait/pic1.jpg"
                        />
                    ) : (
                        /* BULK MULTI-IMAGE UPLOAD CONTAINER */
                        <div>
                            <label className="admin-label" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <span>Bulk Project Images ({images.length} Selected)<Req /></span>
                                {images.length > 0 && (
                                    <span style={{ fontSize: '12px', color: '#10b981', fontWeight: '700' }}>
                                        ✓ {images.length} Image(s) Ready to Save
                                    </span>
                                )}
                            </label>

                            {/* BULK DRAG & DROP ZONE */}
                            <div
                                onDragOver={(e) => { e.preventDefault(); e.stopPropagation(); setIsDragging(true); }}
                                onDragLeave={(e) => { e.preventDefault(); e.stopPropagation(); setIsDragging(false); }}
                                onDrop={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    setIsDragging(false);
                                    if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
                                        handleFilesSelect(e.dataTransfer.files);
                                    }
                                }}
                                onClick={() => bulkInputRef.current && bulkInputRef.current.click()}
                                style={{
                                    border: isDragging ? '2px dashed #10b981' : '2px dashed #cbd5e1',
                                    backgroundColor: isDragging ? 'rgba(16, 185, 129, 0.05)' : '#f8fafc',
                                    borderRadius: '12px',
                                    padding: '28px 20px',
                                    textAlign: 'center',
                                    cursor: 'pointer',
                                    transition: 'all 0.2s ease',
                                    marginBottom: '15px'
                                }}
                            >
                                {uploadingCount > 0 ? (
                                    <div style={{ padding: '15px' }}>
                                        <i className="fa fa-circle-o-notch fa-spin" style={{ fontSize: '32px', color: '#10b981' }} />
                                        <p style={{ margin: '12px 0 0 0', fontSize: '14px', fontWeight: '700', color: '#0f172a' }}>
                                            Processing &amp; Uploading Images... ({uploadingCount} remaining)
                                        </p>
                                    </div>
                                ) : (
                                    <>
                                        <div style={{
                                            width: '52px',
                                            height: '52px',
                                            borderRadius: '50%',
                                            backgroundColor: 'rgba(16, 185, 129, 0.1)',
                                            color: '#10b981',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            margin: '0 auto 12px auto',
                                            fontSize: '22px'
                                        }}>
                                            <i className="fa fa-cloud-upload" />
                                        </div>
                                        <h4 style={{ margin: '0 0 6px 0', fontSize: '16px', fontWeight: '700', color: '#0f172a' }}>
                                            Drag &amp; Drop Multiple Images Here, or <span style={{ color: '#10b981', textDecoration: 'underline' }}>Browse Files</span>
                                        </h4>
                                        <p style={{ margin: 0, fontSize: '13px', color: '#64748b' }}>
                                            Select 1 or multiple project photos at once (JPG, PNG, WEBP, SVG)
                                        </p>
                                    </>
                                )}
                            </div>

                            {/* HIDDEN MULTI-FILE INPUT */}
                            <input
                                type="file"
                                ref={bulkInputRef}
                                accept="image/*"
                                multiple
                                onChange={(e) => {
                                    if (e.target.files && e.target.files.length > 0) {
                                        handleFilesSelect(e.target.files);
                                    }
                                }}
                                style={{ display: 'none' }}
                            />

                            {/* DIRECT URL ADD BUTTON */}
                            <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '12px' }}>
                                <button
                                    type="button"
                                    onClick={() => setShowUrlInput(!showUrlInput)}
                                    style={{ background: 'none', border: 'none', color: '#64748b', fontSize: '12px', cursor: 'pointer', textDecoration: 'underline' }}
                                >
                                    {showUrlInput ? 'Hide URL Link Input' : '+ Paste Direct Image Link'}
                                </button>
                            </div>

                            {showUrlInput && (
                                <div style={{ marginBottom: '15px', display: 'flex', gap: '8px' }}>
                                    <input
                                        type="text"
                                        className="admin-input"
                                        placeholder="Paste image URL (e.g. /images/projects/portrait/pic1.jpg or https://...)"
                                        value={urlText}
                                        onChange={(e) => setUrlText(e.target.value)}
                                        style={{ fontSize: '13px' }}
                                    />
                                    <button
                                        type="button"
                                        className="admin-btn admin-btn-primary"
                                        onClick={handleAddUrl}
                                        style={{ padding: '6px 14px', fontSize: '13px', flexShrink: 0 }}
                                    >
                                        Add Link
                                    </button>
                                </div>
                            )}

                            {/* BULK IMAGE PREVIEW GRID */}
                            {images.length > 0 && (
                                <div style={{
                                    backgroundColor: '#ffffff',
                                    border: '1px solid #e2e8f0',
                                    borderRadius: '12px',
                                    padding: '15px',
                                    maxHeight: '220px',
                                    overflowY: 'auto',
                                    boxShadow: 'inset 0 2px 4px rgba(0,0,0,0.02)'
                                }}>
                                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(90px, 1fr))', gap: '12px' }}>
                                        {images.map((imgUrl, idx) => (
                                            <div
                                                key={idx}
                                                style={{
                                                    position: 'relative',
                                                    height: '80px',
                                                    borderRadius: '8px',
                                                    overflow: 'hidden',
                                                    border: '2px solid #10b981',
                                                    boxShadow: '0 2px 8px rgba(16,185,129,0.15)',
                                                    backgroundColor: '#1e293b'
                                                }}
                                            >
                                                <img
                                                    src={getPreviewUrl(imgUrl)}
                                                    alt={`Preview ${idx + 1}`}
                                                    style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                                    onError={(e) => {
                                                        e.target.onerror = null;
                                                        e.target.style.opacity = '0.5';
                                                    }}
                                                />
                                                <span style={{
                                                    position: 'absolute',
                                                    bottom: '3px',
                                                    left: '3px',
                                                    backgroundColor: 'rgba(0,0,0,0.7)',
                                                    color: '#fff',
                                                    fontSize: '10px',
                                                    padding: '1px 5px',
                                                    borderRadius: '4px',
                                                    fontWeight: '700'
                                                }}>
                                                    #{idx + 1}
                                                </span>
                                                <button
                                                    type="button"
                                                    onClick={() => removeImage(idx)}
                                                    title="Remove Image"
                                                    style={{
                                                        position: 'absolute',
                                                        top: '3px',
                                                        right: '3px',
                                                        width: '20px',
                                                        height: '20px',
                                                        borderRadius: '50%',
                                                        backgroundColor: '#ef4444',
                                                        color: '#ffffff',
                                                        border: 'none',
                                                        fontSize: '11px',
                                                        fontWeight: 'bold',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        cursor: 'pointer',
                                                        boxShadow: '0 2px 4px rgba(0,0,0,0.3)'
                                                    }}
                                                >
                                                    ✕
                                                </button>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            )}
                        </div>
                    )}

                    <div className="admin-modal-footer m-t20">
                        <button type="button" className="admin-btn admin-btn-secondary" onClick={onClose}>Cancel</button>
                        <button
                            type="submit"
                            className="admin-btn admin-btn-primary"
                            disabled={!isEdit && images.length === 0}
                            style={{ opacity: (!isEdit && images.length === 0) ? 0.6 : 1 }}
                        >
                            {isEdit ? 'Save Project' : `Save ${images.length > 0 ? `${images.length} ` : ''}Projects`}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default ProjectModal;
